import { Component } from '@angular/core';
import { TalentHappyPathDataService } from "../shared/service/talent-happy-path-data-service";
import { getJobBoardUrl } from "../shared/util/talent-happy-path-util";

@Component({
  selector: 'app-job-posting-closed',
  standalone: false,
  templateUrl: './job-posting-closed.component.html',
  styleUrl: './job-posting-closed.component.scss'
})
export class JobPostingClosedComponent {
  postingInfo: PostingInfo;
  jobBoardUrl: string;

  constructor(private talentHappyPathDataService: TalentHappyPathDataService) {
  }

  ngOnInit() {
    this.postingInfo = this.talentHappyPathDataService.postingInfo;
    const countryId = this.postingInfo ? this.postingInfo.countryId : 0;
    this.jobBoardUrl = getJobBoardUrl(countryId)
  }
}
